import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'ui-modal-default',
  templateUrl: './ui-modal-default.component.html',
  styleUrls: ['./ui-modal-default.component.scss']
})
export class UiModalDefaultComponent {
  confirmMessage: string;
  menssageSubtitle: string;
  confirmMessageButton: string;
  modalError: boolean;
  cancelButton = true;

  constructor(public dialogDefault: MatDialogRef<UiModalDefaultComponent>) {}
}
